import React from "react";
import "../../../css/buttons/TertiaryButton.css";

const TertiaryButton = ({ onClick, text }) => {
  return (
    <button className="tertiary-button" onClick={onClick}>
      <div className="button-text">{text}</div>
    </button>
  );
};

export default TertiaryButton;
